module.exports = __webpack_public_path__ + "static/meta-image-3ccd0e42dbe92fcec3cffe999e0c5d42.jpg";